import { isRight } from "fp-ts/lib/Either";
import * as t from "io-ts";
import { PathReporter } from "io-ts/lib/PathReporter";

const Config = t.type({
  stage: t.string,
  version: t.union([t.string, t.undefined]),
  cloudCredID: t.string,
  ubuntuTemplateID: t.string, // TODO pull from API
  webstormTemplateID: t.string, // TODO pull from API
  intellijCommunityTemplateID: t.string, // TODO pull from API
  pycharmCommunityTemplateID: t.string, // TODO pull from API
  intellijUltimateTemplateID: t.string, // TODO pull from API
  pycharmProfessionalTemplateID: t.string, // TODO pull from API
  clionTemplateID: t.string, // TODO pull from API
  dataGripTemplateID: t.string, // TODO pull from API
  mpsTemplateID: t.string, // TODO pull from API
  riderTemplateID: t.string, // TODO pull from API
  phpstormTemplateID: t.string, // TODO pull from API
  golandTemplateID: t.string, // TODO pull from API
  rubymineTemplateID: t.string, // TODO pull from API
  brevApiUrl: t.string,
  devplaneApiUrl: t.string,
  sentryDsn: t.string,
  stripePublishableKey: t.string,
  githubOauthClientID: t.string,
  githubOauthRedirectRoute: t.string,
  githubOauthScope: t.string,
  githubOauthAuthorizationEndpoint: t.string,
});

const configRes = Config.decode({
  stage: import.meta.env.VITE_STAGE || "local",
  version: import.meta.env.VITE_VERSION || "",
  cloudCredID:
    import.meta.env.VITE_CLOUD_CRED_ID ||
    import.meta.env.VITE_WORKSPACE_GROUP_ID ||
    "",
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || "",
  ubuntuTemplateID: import.meta.env.VITE_UBUNTU_TEMPLATE_ID || "",
  webstormTemplateID: import.meta.env.VITE_UBUNTU_WEBSTORM_TEMPLATE_ID || "",
  intellijCommunityTemplateID:
    import.meta.env.VITE_UBUNTU_INTELLIJCOMMUNITY_TEMPLATE_ID || "",
  pycharmCommunityTemplateID:
    import.meta.env.VITE_UBUNTU_PYCHARMCOMMUNITY_TEMPLATE_ID || "",
  intellijUltimateTemplateID:
    import.meta.env.VITE_UBUNTU_INTELLIJULTIMATE_TEMPLATE_ID || "",
  pycharmProfessionalTemplateID:
    import.meta.env.VITE_UBUNTU_PYCHARMPROFESSIONAL_TEMPLATE_ID || "",
  clionTemplateID: import.meta.env.VITE_UBUNTU_CLION_TEMPLATE_ID || "",
  dataGripTemplateID: import.meta.env.VITE_UBUNTU_DATAGRIP_TEMPLATE_ID || "",
  mpsTemplateID: import.meta.env.VITE_UBUNTU_MPS_TEMPLATE_ID || "",
  riderTemplateID: import.meta.env.VITE_UBUNTU_RIDER_TEMPLATE_ID || "",
  phpstormTemplateID: import.meta.env.VITE_UBUNTU_PHPSTORM_TEMPLATE_ID || "",
  golandTemplateID: import.meta.env.VITE_UBUNTU_GOLAND_TEMPLATE_ID || "",
  rubymineTemplateID: import.meta.env.VITE_UBUNTU_RUBYMINE_TEMPLATE_ID || "",
  brevApiUrl: import.meta.env.VITE_BREV_API_BASE_URL || "",
  devplaneApiUrl: import.meta.env.VITE_DEVPLANE_API_BASE_URL || "",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || "",
  githubOauthClientID: import.meta.env.VITE_GITHUB_OAUTH_CLIENT_ID || "",
  githubOauthRedirectRoute:
    import.meta.env.VITE_GITHUB_OAUTH_REDIRECT_ROUTE || "",
  githubOauthScope: import.meta.env.VITE_GITHUB_OAUTH_SCOPE || "",
  githubOauthAuthorizationEndpoint:
    import.meta.env.VITE_GITHUB_AUTHORIZATION_ENDPOINT || "",
});

if (!isRight(configRes)) {
  const res = PathReporter.report(configRes);
  throw Error(res.join("\n"));
}

export default configRes.right;
